var $ = jQuery.noConflict();

// jQuery(window).on('load', function() {
// 	hidePreloader();
// });
window.onload = function(){
	setInterval(function(){
		hidePreloader();
	}, 200);
};

function hidePreloader() {
  jQuery('section.preloader-wrapper').addClass('done');
}
